import styled from "styled-components";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

export const FilterCategoriesListContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-inline: 15px;
    margin: 15px 0;
    background-color: ${props => hexToRgba(props.theme.colors.background, 0.7)};
    border-radius: 10px;
    user-select: none;
    overflow-y: auto;
`;